import React, { useState, useEffect } from 'react';
import { LOCAL_CATALOG } from './CatalogData';

export default function Home({ setCurrentPage, handleProductClick, addToCart, cart, handleSingleInquiryClick }) {
  const banners = [
    '/images/banner (1).webp',
    '/images/banner (2).webp',
    '/images/banner (3).webp',
    '/images/banner (4).webp',
    '/images/banner (5).webp'
  ];

  const [currentSlide, setCurrentSlide] = useState(0);
  const [emailInput, setEmailInput] = useState('');
  const [isMobile, setIsMobile] = useState(false);
  const [hoveredCard, setHoveredCard] = useState(null);
  const [addedItems, setAddedItems] = useState({});

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
    };
    handleResize();
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  // Banner cycling
  useEffect(() => {
    const slideInterval = setInterval(() => {
      setCurrentSlide((prevSlide) => (prevSlide + 1) % banners.length);
    }, 4000);

    return () => clearInterval(slideInterval);
  }, [banners.length]);

  const categories = Array.from(new Set(LOCAL_CATALOG.map(item => item.category || 'General'))).slice(0, 3);

  const handleSubscribeSubmit = () => {
    if (!emailInput || !emailInput.includes('@')) {
      alert("Please provide a valid corporate email address.");
      return;
    }

    const recipient = "shabaaztradingco04@gmail.com";
    const subject = encodeURIComponent("New Inventory Alert Subscription Request");
    const body = encodeURIComponent(
      `Hello Shabaaz Trading Co. Team,\n\n` +
      `Please add my corporate email to your subscriber alerts roster for incoming structural inventory items and updates.\n\n` +
      `Subscriber Email: ${emailInput}\n\n` +
      `Regards.`
    );

    window.open(`mailto:${recipient}?subject=${subject}?&body=${body}`, '_self');
    setEmailInput('');
  };

  // 🛒 Enhanced add to cart handler with animation feedback
  const handleAddToCart = (asset, event) => {
    if (event) {
      event.stopPropagation();
    }
    
    // If already in cart, show feedback
    if (cart.some(item => item.id === asset.id)) {
      // Flash animation for already added items
      setAddedItems(prev => ({ ...prev, [asset.id]: 'flash' }));
      setTimeout(() => {
        setAddedItems(prev => ({ ...prev, [asset.id]: undefined }));
      }, 500);
      return;
    }
    
    // Get the button element for animation reference
    let sourceElement = null;
    if (event && event.currentTarget) {
      sourceElement = event.currentTarget;
    } else if (event && event.target) {
      sourceElement = event.target.closest('button') || event.target;
    }
    
    // Call parent addToCart with the asset and event for animation
    addToCart(asset, event || sourceElement);
    
    // Show "Added!" state
    setAddedItems(prev => ({ ...prev, [asset.id]: 'added' }));
    setTimeout(() => {
      setAddedItems(prev => ({ ...prev, [asset.id]: undefined }));
    }, 1500);
  };

  return (
    <div style={{ width: '100%', overflowX: 'hidden', backgroundColor: '#f8fafc', fontFamily: 'system-ui, sans-serif' }}>
      
      {/* HERO CAROUSEL */}
      <div style={{ 
        position: 'relative', 
        height: isMobile ? '240px' : '500px', 
        backgroundColor: '#0f172a', 
        display: 'flex', 
        justifyContent: 'center', 
        alignItems: 'center', 
        overflow: 'hidden',
        width: '100%',
        transition: 'height 0.3s ease',
        cursor: 'pointer'
      }}>
        {banners.map((slideUrl, index) => (
          <div
            key={index}
            onClick={() => setCurrentPage('products')}
            style={{
              position: 'absolute',
              top: 0,
              left: 0,
              width: '100%',
              height: '100%',
              opacity: currentSlide === index ? 1 : 0, 
              transition: 'opacity 800ms ease-in-out', 
              zIndex: currentSlide === index ? 2 : 1
            }}
          >
            <img 
              src={slideUrl} 
              alt={`Shabaaz Banner Showcase ${index + 1}`} 
              style={{ 
                width: '100%', 
                height: '100%', 
                objectFit: isMobile ? 'cover' : 'fill'
              }} 
              onError={(e) => {
                if(!e.target.src.includes('.png')) {
                  e.target.src = slideUrl.replace('.jpg', '.png');
                }
              }}
            />
          </div>
        ))}

        {/* CAROUSEL INDICATOR DOTS */}
        <div style={{ position: 'absolute', bottom: isMobile ? '12px' : '24px', left: '50%', transform: 'translateX(-50%)', display: 'flex', gap: '10px', zIndex: 10 }}>
          {banners.map((_, index) => (
            <button
              key={index}
              onClick={(e) => {
                e.stopPropagation();
                setCurrentSlide(index);
              }}
              style={{
                width: currentSlide === index ? (isMobile ? '20px' : '28px') : '8px',
                height: '8px',
                borderRadius: '9999px',
                border: 'none',
                backgroundColor: currentSlide === index ? '#ffffff' : 'rgba(255, 255, 255, 0.5)',
                cursor: 'pointer',
                boxShadow: '0 1px 3px rgba(0,0,0,0.4)',
                transition: 'all 0.4s ease'
              }}
              title={`Go to slide ${index + 1}`}
            />
          ))}
        </div>
      </div>
     
      {/* PRODUCT TRACKS SECTION */}
      <section style={{ padding: isMobile ? '15px 15px' : '40px 40px', maxWidth: '1280px', margin: '0 auto' }}>
        {categories.map((catName) => {
          const rowProducts = LOCAL_CATALOG.filter(item => (item.category || 'General') === catName);

          return (
            <div key={catName} style={{ marginBottom: isMobile ? '15px' : '25px' }}>
              
              {/* Row Header */}
              <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start', marginBottom: '10px' }}>
                <h3 style={{ fontSize: isMobile ? '1.1rem' : '1.5rem', fontWeight: '800', letterSpacing: '-0.02em', color: '#0f172a', margin: 0 }}>
                  {catName}
                </h3>
                <div style={{ width: '30px', height: '3px', backgroundColor: '#0284c7', marginTop: '4px', borderRadius: '2px' }} />
              </div>

              {/* Horizontal Scroll Track */}
              <div style={{ 
                display: 'flex', 
                flexWrap: isMobile ? 'nowrap' : 'wrap', 
                gap: isMobile ? '10px' : '20px', 
                overflowX: isMobile ? 'auto' : 'visible',
                paddingBottom: isMobile ? '10px' : '0',
                WebkitOverflowScrolling: 'touch'
              }}>
                {rowProducts.map(asset => {
                  const isInCart = cart.some(item => item.id === asset.id);
                  const isCardHovered = hoveredCard === asset.id;
                  const buttonState = addedItems[asset.id];
                  
                  return (
                    <div 
                      key={asset.id} 
                      onClick={() => handleProductClick(asset)}
                      onMouseEnter={() => setHoveredCard(asset.id)}
                      onMouseLeave={() => setHoveredCard(null)}
                      style={{ 
                        flex: isMobile ? '0 0 150px' : '0 1 calc(25% - 15px)',
                        width: isMobile ? '150px' : 'auto',
                        height: isMobile ? '150px' : '260px', 
                        maxWidth: '380px',
                        boxSizing: 'border-box',
                        border: '1px solid #e2e8f0', 
                        borderRadius: '8px', 
                        overflow: 'hidden', 
                        cursor: 'pointer', 
                        backgroundColor: '#ffffff',
                        position: 'relative', 
                        boxShadow: isCardHovered ? '0 10px 15px -3px rgba(0,0,0,0.05)' : '0 2px 4px rgba(0,0,0,0.01)',
                        transform: (!isMobile && isCardHovered) ? 'translateY(-4px)' : 'translateY(0)',
                        transition: 'all 0.3s ease',
                      }}
                    >
                      <div style={{ width: '100%', height: '100%', backgroundColor: '#f8fafc', position: 'relative' }}>
                        <img 
                          src={asset.image} 
                          alt={asset.name} 
                          style={{ 
                            width: '100%', 
                            height: '100%', 
                            objectFit: 'cover',
                            transform: isCardHovered ? 'scale(1.03)' : 'scale(1)',
                            transition: 'transform 0.4s ease'
                          }} 
                        />
                        
                        <div style={{
                          position: 'absolute',
                          bottom: 0,
                          left: 0,
                          right: 0,
                          background: 'linear-gradient(to top, rgba(15,23,42,0.95) 0%, rgba(15,23,42,0.7) 70%, rgba(15,23,42,0) 100%)',
                          padding: isMobile ? '25px 8px 8px 8px' : '40px 12px 12px 12px',
                          display: 'flex',
                          flexDirection: 'column',
                          justifyContent: 'flex-end'
                        }}>
                          <h4 style={{ 
                            margin: '0 0 6px 0', 
                            fontSize: isMobile ? '0.75rem' : '0.95rem', 
                            fontWeight: '700', 
                            lineHeight: '1.2', 
                            color: '#ffffff', 
                            display: '-webkit-box',
                            WebkitLineClamp: 1,
                            WebkitBoxOrient: 'vertical',
                            overflow: 'hidden'
                          }}>
                            {asset.name}
                          </h4>

                          <div style={{ display: 'flex', gap: '4px' }}>
                            {/* 🛒 ADD TO CART BUTTON WITH ANIMATION SUPPORT */}
                            <button 
                              onClick={(e) => handleAddToCart(asset, e)} 
                              style={{ 
                                flex: 1,
                                padding: isMobile ? '4px 2px' : '6px 4px', 
                                backgroundColor: isInCart ? '#22c55e' : (buttonState === 'added' ? '#22c55e' : '#efff13'),
                                color: isInCart ? '#ffffff' : (buttonState === 'added' ? '#ffffff' : '#000000'), 
                                border: 'none', 
                                borderRadius: '4px', 
                                fontWeight: '700', 
                                fontSize: isMobile ? '0.65rem' : '0.75rem', 
                                cursor: isInCart ? 'default' : 'pointer',
                                transition: 'all 0.3s ease',
                                transform: buttonState === 'added' ? 'scale(0.95)' : 'scale(1)',
                                position: 'relative',
                                overflow: 'hidden'
                              }}
                            >
                              {isInCart ? '✓ Added' : (buttonState === 'added' ? '✓ Added!' : '🛒 Add')}
                              
                              {/* Ripple effect for added items */}
                              {buttonState === 'added' && (
                                <span style={{
                                  position: 'absolute',
                                  top: '50%',
                                  left: '50%',
                                  width: '0',
                                  height: '0',
                                  borderRadius: '50%',
                                  backgroundColor: 'rgba(255,255,255,0.4)',
                                  transform: 'translate(-50%, -50%)',
                                  animation: 'ripple 0.6s ease-out forwards'
                                }} />
                              )}
                            </button>
                            
                            {/* INQUIRE BUTTON */}
                            <button 
                              onClick={(e) => { e.stopPropagation(); handleSingleInquiryClick(asset); }} 
                              style={{ 
                                flex: 1,
                                padding: isMobile ? '4px 2px' : '6px 4px', 
                                color: '#ffffff', 
                                border: '1px solid #ef4444', 
                                backgroundColor: '#dc2626',
                                borderRadius: '4px', 
                                fontSize: isMobile ? '0.65rem' : '0.75rem', 
                                fontWeight: '700', 
                                cursor: 'pointer',
                                transition: 'all 0.2s ease'
                              }}
                              onMouseEnter={(e) => e.currentTarget.style.backgroundColor = '#b91c1c'}
                              onMouseLeave={(e) => e.currentTarget.style.backgroundColor = '#dc2626'}
                            >
                              📧 Inquire
                            </button>
                          </div>
                        </div>

                        <div style={{ position: 'absolute', top: '6px', left: '6px', backgroundColor: 'rgba(15,23,42,0.75)', padding: '2px 6px', borderRadius: '4px', fontSize: '0.6rem', fontWeight: '600', color: '#ffffff' }}>
                          ID: {asset.id}
                        </div>

                        {/* In Cart Badge */}
                        {isInCart && (
                          <div style={{
                            position: 'absolute',
                            top: '6px',
                            right: '6px',
                            backgroundColor: '#22c55e',
                            color: 'white',
                            padding: '2px 8px',
                            borderRadius: '12px',
                            fontSize: '0.55rem',
                            fontWeight: '700',
                            display: 'flex',
                            alignItems: 'center',
                            gap: '4px',
                            animation: 'fadeIn 0.3s ease'
                          }}>
                            ✓ In Cart
                          </div>
                        )}
                      </div>

                    </div>
                  );
                })}
              </div>
            </div>
          );
        })}
      </section>

      {/* PROMOTIONAL CATEGORY CALLOUTS */}
      <section style={{ padding: '20px 20px', maxWidth: '1280px', margin: '0 auto 40px auto' }}>
        <div style={{ display: 'flex', flexWrap: 'wrap', gap: '20px' }}>
          
          <div style={{ flex: '1', minWidth: '280px', backgroundColor: '#0f172a', color: 'white', padding: isMobile ? '25px' : '40px', borderRadius: '16px', display: 'flex', flexDirection: 'column', justifyContent: 'space-between', minHeight: '180px' }}>
            <div>
              <h3 style={{ margin: '0 0 10px 0', fontSize: '1.5rem' }}>Bulk Inquiries</h3>
              <p style={{ margin: '0 0 20px 0', color: '#94a3b8', fontSize: '0.9rem' }}>Need custom pricing setups for multi-unit enterprise architectures? Contact our sales desk direct.</p>
            </div>
            <div style={{ display: 'flex', gap: '10px', flexWrap: 'wrap' }}>
              <button onClick={() => setCurrentPage('products')} style={{ padding: '10px 20px', backgroundColor: '#ffffff', color: '#0f172a', border: 'none', borderRadius: '6px', fontWeight: '600', cursor: 'pointer', transition: 'all 0.2s ease' }}>
                Explore Collections
              </button>
              <button onClick={() => setCurrentPage('contact')} style={{ padding: '10px 20px', backgroundColor: 'transparent', color: '#ffffff', border: '1px solid #ffffff', borderRadius: '6px', fontWeight: '600', cursor: 'pointer', transition: 'all 0.2s ease' }}>
                Get Quote
              </button>
            </div>
          </div>

          <div style={{ flex: '1', minWidth: '280px', backgroundColor: '#e2e8f0', color: '#0f172a', padding: isMobile ? '25px' : '40px', borderRadius: '16px', display: 'flex', flexDirection: 'column', justifyContent: 'space-between', minHeight: '180px' }}>
            <div>
              <h3 style={{ margin: '0 0 10px 0', fontSize: '1.5rem' }}>Full Hardware Index</h3>
              <p style={{ margin: '0 0 20px 0', color: '#475569', fontSize: '0.9rem' }}>Browse through our complete repository of cutting edge mechanical and tech gear modules.</p>
            </div>
            <div style={{ display: 'flex', gap: '10px', flexWrap: 'wrap' }}>
              <button onClick={() => setCurrentPage('products')} style={{ padding: '10px 20px', backgroundColor: '#0f172a', color: '#ffffff', border: 'none', borderRadius: '6px', fontWeight: '600', cursor: 'pointer', transition: 'all 0.2s ease' }}>
                View Catalog
              </button>
              <button onClick={() => setCurrentPage('certificates')} style={{ padding: '10px 20px', backgroundColor: '#ffffff', color: '#0f172a', border: '1px solid #cbd5e1', borderRadius: '6px', fontWeight: '600', cursor: 'pointer', transition: 'all 0.2s ease' }}>
                Our Certifications
              </button>
            </div>
          </div>
          
        </div>
      </section>

      {/* ANIMATION STYLES */}
      <style>{`
        @keyframes ripple {
          0% {
            width: 0;
            height: 0;
            opacity: 1;
          }
          100% {
            width: 100px;
            height: 100px;
            opacity: 0;
          }
        }
        
        @keyframes fadeIn {
          0% {
            opacity: 0;
            transform: scale(0.8);
          }
          100% {
            opacity: 1;
            transform: scale(1);
          }
        }
        
        .card-enter {
          animation: cardEnter 0.3s ease forwards;
        }
        
        @keyframes cardEnter {
          0% {
            opacity: 0;
            transform: translateY(10px);
          }
          100% {
            opacity: 1;
            transform: translateY(0);
          }
        }
      `}</style>
    </div>
  );
}
